module.exports = __webpack_public_path__ + "static/CircularStd-Medium-44d10b7173f802a0f8407111d1ba0d27.ttf";